import React from "react";

export default class HowvideoDumpsters extends React.Component  
{    
    render()
    {
        return (
            <div class="block howvideo services mb-5">     
                <h3>How It Works</h3>           
                <div className="card">  
                    <p>Learn how Hometown Dumpster Rental makes it easy to automate the dumpster quote and book process, saving you time and booking more jobs.</p>
                    <iframe src="https://www.youtube-nocookie.com/embed/IZ8qErWBaqg" width="560" height="315" frameborder="0"></iframe>
                    <a className="btn btn-primary" href="/pro/guide/leads-for-dumpster-rental">Watch Tutorial</a>
                </div>
            </div>
        )
    }
};